/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout.index'
import { Route as LayoutLangQualitySurveyLayoutRouteImport } from './routes/_layout.$lang/quality-survey/_layout'
import { Route as LayoutLangQualitySurveyLayoutIndexRouteImport } from './routes/_layout.$lang/quality-survey/_layout/index'
import { Route as LayoutLangQualitySurveyLayoutSubmittedRouteImport } from './routes/_layout.$lang/quality-survey/_layout/submitted'
import { Route as LayoutLangQualitySurveyLayoutNotFoundRouteImport } from './routes/_layout.$lang/quality-survey/_layout/not-found'
import { Route as LayoutLangQualitySurveyLayoutExpiredRouteImport } from './routes/_layout.$lang/quality-survey/_layout/expired'
import { Route as LayoutLangQualitySurveyLayoutAlreadySubmittedRouteImport } from './routes/_layout.$lang/quality-survey/_layout/already-submitted'
import { Route as LayoutLangQualitySurveyLayoutNotCompletedIndexRouteImport } from './routes/_layout.$lang/quality-survey/_layout/not-completed/index'
import { Route as LayoutLangQualitySurveyLayoutNotCompletedSubmittedRouteImport } from './routes/_layout.$lang/quality-survey/_layout/not-completed/submitted'

const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutLangQualitySurveyLayoutRoute =
  LayoutLangQualitySurveyLayoutRouteImport.update({
    id: '/$lang/quality-survey/_layout',
    path: '/$lang/quality-survey',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutLangQualitySurveyLayoutIndexRoute =
  LayoutLangQualitySurveyLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutLangQualitySurveyLayoutRoute,
  } as any)
const LayoutLangQualitySurveyLayoutSubmittedRoute =
  LayoutLangQualitySurveyLayoutSubmittedRouteImport.update({
    id: '/submitted',
    path: '/submitted',
    getParentRoute: () => LayoutLangQualitySurveyLayoutRoute,
  } as any)
const LayoutLangQualitySurveyLayoutNotFoundRoute =
  LayoutLangQualitySurveyLayoutNotFoundRouteImport.update({
    id: '/not-found',
    path: '/not-found',
    getParentRoute: () => LayoutLangQualitySurveyLayoutRoute,
  } as any)
const LayoutLangQualitySurveyLayoutExpiredRoute =
  LayoutLangQualitySurveyLayoutExpiredRouteImport.update({
    id: '/expired',
    path: '/expired',
    getParentRoute: () => LayoutLangQualitySurveyLayoutRoute,
  } as any)
const LayoutLangQualitySurveyLayoutAlreadySubmittedRoute =
  LayoutLangQualitySurveyLayoutAlreadySubmittedRouteImport.update({
    id: '/already-submitted',
    path: '/already-submitted',
    getParentRoute: () => LayoutLangQualitySurveyLayoutRoute,
  } as any)
const LayoutLangQualitySurveyLayoutNotCompletedIndexRoute =
  LayoutLangQualitySurveyLayoutNotCompletedIndexRouteImport.update({
    id: '/not-completed/',
    path: '/not-completed/',
    getParentRoute: () => LayoutLangQualitySurveyLayoutRoute,
  } as any)
const LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute =
  LayoutLangQualitySurveyLayoutNotCompletedSubmittedRouteImport.update({
    id: '/not-completed/submitted',
    path: '/not-completed/submitted',
    getParentRoute: () => LayoutLangQualitySurveyLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/$lang/quality-survey': typeof LayoutLangQualitySurveyLayoutRouteWithChildren
  '/$lang/quality-survey/already-submitted': typeof LayoutLangQualitySurveyLayoutAlreadySubmittedRoute
  '/$lang/quality-survey/expired': typeof LayoutLangQualitySurveyLayoutExpiredRoute
  '/$lang/quality-survey/not-found': typeof LayoutLangQualitySurveyLayoutNotFoundRoute
  '/$lang/quality-survey/submitted': typeof LayoutLangQualitySurveyLayoutSubmittedRoute
  '/$lang/quality-survey/': typeof LayoutLangQualitySurveyLayoutIndexRoute
  '/$lang/quality-survey/not-completed/submitted': typeof LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute
  '/$lang/quality-survey/not-completed/': typeof LayoutLangQualitySurveyLayoutNotCompletedIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof LayoutIndexRoute
  '/$lang/quality-survey/already-submitted': typeof LayoutLangQualitySurveyLayoutAlreadySubmittedRoute
  '/$lang/quality-survey/expired': typeof LayoutLangQualitySurveyLayoutExpiredRoute
  '/$lang/quality-survey/not-found': typeof LayoutLangQualitySurveyLayoutNotFoundRoute
  '/$lang/quality-survey/submitted': typeof LayoutLangQualitySurveyLayoutSubmittedRoute
  '/$lang/quality-survey': typeof LayoutLangQualitySurveyLayoutIndexRoute
  '/$lang/quality-survey/not-completed/submitted': typeof LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute
  '/$lang/quality-survey/not-completed': typeof LayoutLangQualitySurveyLayoutNotCompletedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/$lang/quality-survey/_layout': typeof LayoutLangQualitySurveyLayoutRouteWithChildren
  '/_layout/$lang/quality-survey/_layout/already-submitted': typeof LayoutLangQualitySurveyLayoutAlreadySubmittedRoute
  '/_layout/$lang/quality-survey/_layout/expired': typeof LayoutLangQualitySurveyLayoutExpiredRoute
  '/_layout/$lang/quality-survey/_layout/not-found': typeof LayoutLangQualitySurveyLayoutNotFoundRoute
  '/_layout/$lang/quality-survey/_layout/submitted': typeof LayoutLangQualitySurveyLayoutSubmittedRoute
  '/_layout/$lang/quality-survey/_layout/': typeof LayoutLangQualitySurveyLayoutIndexRoute
  '/_layout/$lang/quality-survey/_layout/not-completed/submitted': typeof LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute
  '/_layout/$lang/quality-survey/_layout/not-completed/': typeof LayoutLangQualitySurveyLayoutNotCompletedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang/quality-survey'
    | '/$lang/quality-survey/already-submitted'
    | '/$lang/quality-survey/expired'
    | '/$lang/quality-survey/not-found'
    | '/$lang/quality-survey/submitted'
    | '/$lang/quality-survey/'
    | '/$lang/quality-survey/not-completed/submitted'
    | '/$lang/quality-survey/not-completed/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang/quality-survey/already-submitted'
    | '/$lang/quality-survey/expired'
    | '/$lang/quality-survey/not-found'
    | '/$lang/quality-survey/submitted'
    | '/$lang/quality-survey'
    | '/$lang/quality-survey/not-completed/submitted'
    | '/$lang/quality-survey/not-completed'
  id:
    | '__root__'
    | '/_layout'
    | '/_layout/'
    | '/_layout/$lang/quality-survey/_layout'
    | '/_layout/$lang/quality-survey/_layout/already-submitted'
    | '/_layout/$lang/quality-survey/_layout/expired'
    | '/_layout/$lang/quality-survey/_layout/not-found'
    | '/_layout/$lang/quality-survey/_layout/submitted'
    | '/_layout/$lang/quality-survey/_layout/'
    | '/_layout/$lang/quality-survey/_layout/not-completed/submitted'
    | '/_layout/$lang/quality-survey/_layout/not-completed/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout': {
      id: '/_layout/$lang/quality-survey/_layout'
      path: '/$lang/quality-survey'
      fullPath: '/$lang/quality-survey'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout/': {
      id: '/_layout/$lang/quality-survey/_layout/'
      path: '/'
      fullPath: '/$lang/quality-survey/'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutIndexRouteImport
      parentRoute: typeof LayoutLangQualitySurveyLayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout/submitted': {
      id: '/_layout/$lang/quality-survey/_layout/submitted'
      path: '/submitted'
      fullPath: '/$lang/quality-survey/submitted'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutSubmittedRouteImport
      parentRoute: typeof LayoutLangQualitySurveyLayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout/not-found': {
      id: '/_layout/$lang/quality-survey/_layout/not-found'
      path: '/not-found'
      fullPath: '/$lang/quality-survey/not-found'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutNotFoundRouteImport
      parentRoute: typeof LayoutLangQualitySurveyLayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout/expired': {
      id: '/_layout/$lang/quality-survey/_layout/expired'
      path: '/expired'
      fullPath: '/$lang/quality-survey/expired'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutExpiredRouteImport
      parentRoute: typeof LayoutLangQualitySurveyLayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout/already-submitted': {
      id: '/_layout/$lang/quality-survey/_layout/already-submitted'
      path: '/already-submitted'
      fullPath: '/$lang/quality-survey/already-submitted'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutAlreadySubmittedRouteImport
      parentRoute: typeof LayoutLangQualitySurveyLayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout/not-completed/': {
      id: '/_layout/$lang/quality-survey/_layout/not-completed/'
      path: '/not-completed'
      fullPath: '/$lang/quality-survey/not-completed/'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutNotCompletedIndexRouteImport
      parentRoute: typeof LayoutLangQualitySurveyLayoutRoute
    }
    '/_layout/$lang/quality-survey/_layout/not-completed/submitted': {
      id: '/_layout/$lang/quality-survey/_layout/not-completed/submitted'
      path: '/not-completed/submitted'
      fullPath: '/$lang/quality-survey/not-completed/submitted'
      preLoaderRoute: typeof LayoutLangQualitySurveyLayoutNotCompletedSubmittedRouteImport
      parentRoute: typeof LayoutLangQualitySurveyLayoutRoute
    }
  }
}

interface LayoutLangQualitySurveyLayoutRouteChildren {
  LayoutLangQualitySurveyLayoutAlreadySubmittedRoute: typeof LayoutLangQualitySurveyLayoutAlreadySubmittedRoute
  LayoutLangQualitySurveyLayoutExpiredRoute: typeof LayoutLangQualitySurveyLayoutExpiredRoute
  LayoutLangQualitySurveyLayoutNotFoundRoute: typeof LayoutLangQualitySurveyLayoutNotFoundRoute
  LayoutLangQualitySurveyLayoutSubmittedRoute: typeof LayoutLangQualitySurveyLayoutSubmittedRoute
  LayoutLangQualitySurveyLayoutIndexRoute: typeof LayoutLangQualitySurveyLayoutIndexRoute
  LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute: typeof LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute
  LayoutLangQualitySurveyLayoutNotCompletedIndexRoute: typeof LayoutLangQualitySurveyLayoutNotCompletedIndexRoute
}

const LayoutLangQualitySurveyLayoutRouteChildren: LayoutLangQualitySurveyLayoutRouteChildren =
  {
    LayoutLangQualitySurveyLayoutAlreadySubmittedRoute:
      LayoutLangQualitySurveyLayoutAlreadySubmittedRoute,
    LayoutLangQualitySurveyLayoutExpiredRoute:
      LayoutLangQualitySurveyLayoutExpiredRoute,
    LayoutLangQualitySurveyLayoutNotFoundRoute:
      LayoutLangQualitySurveyLayoutNotFoundRoute,
    LayoutLangQualitySurveyLayoutSubmittedRoute:
      LayoutLangQualitySurveyLayoutSubmittedRoute,
    LayoutLangQualitySurveyLayoutIndexRoute:
      LayoutLangQualitySurveyLayoutIndexRoute,
    LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute:
      LayoutLangQualitySurveyLayoutNotCompletedSubmittedRoute,
    LayoutLangQualitySurveyLayoutNotCompletedIndexRoute:
      LayoutLangQualitySurveyLayoutNotCompletedIndexRoute,
  }

const LayoutLangQualitySurveyLayoutRouteWithChildren =
  LayoutLangQualitySurveyLayoutRoute._addFileChildren(
    LayoutLangQualitySurveyLayoutRouteChildren,
  )

interface LayoutRouteChildren {
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutLangQualitySurveyLayoutRoute: typeof LayoutLangQualitySurveyLayoutRouteWithChildren
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutLangQualitySurveyLayoutRoute:
    LayoutLangQualitySurveyLayoutRouteWithChildren,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
